import { render, staticRenderFns } from "./LogApiCandidatoPratico.vue?vue&type=template&id=67130f69&scoped=true"
import script from "./LogApiCandidatoPratico.vue?vue&type=script&lang=js"
export * from "./LogApiCandidatoPratico.vue?vue&type=script&lang=js"
import style0 from "./LogApiCandidatoPratico.vue?vue&type=style&index=0&id=67130f69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67130f69",
  null
  
)

export default component.exports